<div class="min-h-screen">
  <app-header></app-header>

  <div class="bg-th-light-gray flex justify-center">
    <div class="mx-130 mt-12">
      <div
        class="relative min-h-140 min-w-240 flex items-center justify-center overflow-hidden"
        [ngClass]="{
          'mb-14': showHomeButton,
          'mb-30': !showHomeButton,
        }"
      >
        <img
          src="images/bg_admin_error.svg"
          alt="Fondo"
          class="absolute inset-0 min-h-140 min-w-240 object-contain z-0"
        />

        <div class="relative z-20 text-center mt-110">
          <p class="text-th-black text-[36px] font-medium mb-8">
            {{ title }}
          </p>
          <p class="text-lg text-th-gray mb-8">
            {{ description }}
          </p>

          @if (showHomeButton) {
            <div class="max-w-md mx-90">
              <app-button
                class="block w-full"
                variant="primary"
                text="Ir a inicio"
                (click)="goToHome()"
              ></app-button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</div>
